import React, { useState } from "react";
import { Spinner } from "react-bootstrap";
import { Cnt } from "../../Cnt.ThreeDeeCrate.SDK/Cnt.ThreeDeeCrate.SDK";
import { AppSettings } from "../../AppSettings";
import { EMPTY_GUID } from "../../types/Guid";

interface DownloadButtonProps {
  containerId: string;
}

export const DownloadButton: React.FC<DownloadButtonProps> = ({ containerId }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleDownload = async () => {
    setLoading(true);
    setError(null);

    try {
      const api = new Cnt.ThreeDeeCrate.SDK.Api(AppSettings.APIUrl);
      const result = await api.model.GetDownloadUrl(
        containerId || EMPTY_GUID);

      if (!result?.Url) {
        throw new Error("Download URL not found.");
      }

      // Automatically trigger the download
      const link = document.createElement("a");
      link.href = result?.Url;
      link.download = ""; // Optional: set a filename here
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      console.error("Download failed", err);
      setError("Failed to get download URL.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        className="btn btn-success mt-2"
        onClick={handleDownload}
        disabled={loading}
      >
        {loading ? (
          <>
            <Spinner animation="border" size="sm" className="me-2" />
            Preparing download...
          </>
        ) : (
          "Download Model"
        )}
      </button>
      {error && <div className="text-danger mt-2">{error}</div>}
    </>
  );
};
